import { createFileRoute } from '@tanstack/react-router';
import { FormsListPage } from '@web/modules/forms/list/forms-list-page';

export const Route = createFileRoute('/_app/capture/forms/')({
  component: FormsListPage,
});
